module.exports = __webpack_public_path__ + "static/media/lmcst-logo.1375a8d6.png";